var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaggingLow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0H12C12.5304 0 13.0391 0.210714 13.4142 0.585786C13.7893 0.960859 14 1.46957 14 2V12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14H2C1.46957 14 0.960859 13.7893 0.585786 13.4142C0.210714 13.0391 0 12.5304 0 12V2Z",
    fill: "#00A6ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50019 2.5C6.36758 2.5 6.2404 2.55268 6.14664 2.64645C6.05287 2.74021 6.00019 2.86739 6.00019 3V7.875C6.00019 7.90815 5.98702 7.93995 5.96358 7.96339C5.94014 7.98683 5.90834 8 5.87519 8H4.34369C3.89369 8 3.67269 8.548 3.99719 8.86L6.65369 11.4165C6.74683 11.506 6.871 11.556 7.00019 11.556C7.12938 11.556 7.25355 11.506 7.34669 11.4165L10.0032 8.8605C10.3277 8.548 10.1067 8 9.65669 8H8.12519C8.09204 8 8.06024 7.98683 8.0368 7.96339C8.01336 7.93995 8.00019 7.90815 8.00019 7.875V3C8.00019 2.86739 7.94751 2.74021 7.85374 2.64645C7.75997 2.55268 7.6328 2.5 7.50019 2.5H6.50019Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaggingLow);
export default __webpack_public_path__ + "static/media/tagging_low.dd87c0ebaa63ac7b995ae9656b8b017c.svg";
export { ForwardRef as ReactComponent };